export default "__VITE_ASSET__ByiD$C8___"